export class RebateTypeDto {
  id: number;
  name: string;
}